import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Toolbar from '@mui/material/Toolbar';
import PropTypes from 'prop-types';
import React from 'react';
import {
  useDispatch,
  useSelector,
} from 'react-redux';

import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
// import TextField from '@mui/material/TextField';
// import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Timeline from '@mui/lab/Timeline';

import {
  Button,
  CardContent,
  Checkbox,
  Divider,
  Pagination,
  Popover,
  Typography,
} from '@mui/material';

import NoteTypeSelectComponent from '../../../../../../../components/EnumSelects/NoteTypeSelect';
import NoteItem from '../../../../../../../components/NoteItem';
import notesIcon from '../../../../../../../images/unused-undraw-illustrations/notes.svg';
import {
  getHorseNoteHighlights,
  getHorseNotes,
} from '../../../../../../../redux/horse/actions';
import { DEFAULT_NOTE_TYPE_FILTERS } from '../../../../../../../redux/noteTypeFilters/actions';

const HorseNotesSelectPopover = ({
  anchorEl,
  open,
  onClose,
  selectedHorseNotes,
  onChangeSelectedHorseNotes,
}) => {
  const dispatch = useDispatch();
  // const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  // State
  const [pageSize] = React.useState(20);
  const [page, setPage] = React.useState(0);
  const [sortModel] = React.useState([
    {
      field: 'createdTimestamp',
      sort: 'desc',
    },
  ]);
  const [noteTypeFilter, setNoteTypeFilter] = React.useState(DEFAULT_NOTE_TYPE_FILTERS);
  const resolvedNoteTypeFilter = noteTypeFilter && noteTypeFilter.length
    ? noteTypeFilter
    : DEFAULT_NOTE_TYPE_FILTERS;
  // const [startDate, setStartDate] = React.useState(null);
  // const [endDate, setEndDate] = React.useState(null);

  // Redux
  const horse = useSelector((state) => state.horse.horse);
  const horseNotes = useSelector((state) => state.horse.horseNotes);
  const isFetchingHorseNotes = useSelector((state) => state.horse.isFetchingHorseNotes);

  React.useEffect(() => {
    dispatch(getHorseNotes(horse.id, (page - 1), pageSize, sortModel.map((s) => `&sort=${s.field},${s.sort}`), null, resolvedNoteTypeFilter || null));
    dispatch(getHorseNoteHighlights(horse.id));
  }, [horse, page, resolvedNoteTypeFilter]);

  const handleAlternativeTableRowSelect = (horseNote) => {
    if (onChangeSelectedHorseNotes) {
      if (selectedHorseNotes.find((hn) => hn.id === horseNote.id)) {
        // remove
        onChangeSelectedHorseNotes([...selectedHorseNotes.filter((hb) => hb.id !== horseNote.id)])
      } else {
        // add
        onChangeSelectedHorseNotes([...selectedHorseNotes, horseNote])
      }
    }
  }

  const finalHorseNotes = [...selectedHorseNotes.map((n) => ({
    ...n,
    selected: true,
  })), ...horseNotes.content.filter((hn) => !selectedHorseNotes.find((shn) => shn.id === hn.id))]

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      PaperProps={{
        sx: {
          display: 'flex !important',
          flexDirection: 'column !important',
        },
      }}
      slotProps={{
        paper: {
          sx: {
            display: 'flex !important',
            flexDirection: 'column !important',
          },
        },
      }}
    >
      <AppBar
        position="relative"
        color="inherit"
        sx={{
          background: '#fff',
          mb: 2,
        }}
        elevation={2}
      >
        <Container
          maxWidth="100%"
          sx={{
            pt: 1,
            pb: 0.5,
            maxHeight: '90%',
          }}
        >
          <Toolbar disableGutters variant="dense">
            <Grid container spacing={2} justifyContent="space-between">
              <Grid>
                <Grid container spacing={2} alignItems="center">
                  <Grid sx={{ minWidth: 175 }}>
                    <NoteTypeSelectComponent
                      value={noteTypeFilter}
                      onChange={(e) => { setNoteTypeFilter(e.target.value); }}
                      includeAllOption
                      multiple
                      size="small"
                    />
                  </Grid>
                  <Grid>
                    {
                      isFetchingHorseNotes
                        ? (
                          <CircularProgress size={35} />
                        )
                        : (
                          <Box />
                        )
                    }
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Toolbar>
        </Container>
      </AppBar>
      <CardContent
        sx={{
          pt: 1,
          pb: 0.5,
          overflow: 'auto',
          flex: 1,
        }}
      >
        <Timeline>
          {

          }
          {
            finalHorseNotes.map((note) => (
              <Box sx={{ display: 'flex' }} key={`horse-note-${note.id}-selected-${note.selected}`}>
                <Checkbox
                  color="primary"
                  checked={note.selected}
                  onChange={() => handleAlternativeTableRowSelect(note)}
                  sx={{ mr: 2 }}
                />
                <Box sx={{ flex: 1 }}>
                  <NoteItem
                    note={note}
                    horseId={horse.id}
                    pinnedHorseNoteId={horse.activeNote
                      ? horse.activeNote.id
                      : null}
                    key={note.id}
                    includeUserInfo
                    isLoading={isFetchingHorseNotes}
                    // onEdit={() => openAddEditNoteModal(note, noteTypeFilter, closeAddEditModalCallbcak)}
                    isAdmin={false}
                    hideActions
                  />
                </Box>
              </Box>
            ))
          }
          {
            (!isFetchingHorseNotes && horseNotes.content.length === 0) && (
              <Box sx={{ textAlign: 'center' }}>
                <Typography variant="subtitle1" align="center" component="div" sx={{ m: 4 }}>
                  No Notes
                </Typography>
                <img
                  src={notesIcon}
                  alt="girl with notes"
                  style={{
                    width: 250,
                    display: 'block',
                    margin: 'auto',
                    marginBottom: '1rem',
                  }}
                />
              </Box>
            )
          }

        </Timeline>

      </CardContent>
      <Box>
        <Divider />
        <Box
          sx={{
            p: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 1,
          }}
        >
          {(horseNotes.totalPages || 0) > 1 && (
            <Pagination count={horseNotes.totalPages} variant="outlined" page={page} onChange={(event, value) => { setPage(value); }} disabled={isFetchingHorseNotes} />
          )}
          <Button variant="contained" onClick={onClose}>Done</Button>
        </Box>
      </Box>
    </Popover>
  );
}

HorseNotesSelectPopover.propTypes = {
  open: PropTypes.bool,
  anchorEl: PropTypes.any,
  onClose: PropTypes.func,
  selectedHorseNotes: PropTypes.func,
  onChangeSelectedHorseNotes: PropTypes.array,
};

HorseNotesSelectPopover.defaultProps = {
  open: false,
  anchorEl: null,
  onClose: () => { },
  selectedHorseNotes: [],
  onChangeSelectedHorseNotes: () => { },
};

export default (HorseNotesSelectPopover);
